import { DISPATCH_API, WEB_ROUTES } from '~/app/shared/utils/web-config';
import { MUTATION_PAYLOAD, MUTATION_TYPES } from '~/store/types';

export default async ({ app, route, store, query, softRedirect }) => {
  const {
    CLIENT_BLOCKED,
    APPLICATION_ACCEPTED,
    APPLICATION_COMPLETED,
    APPLICATION_CANCELED,
    APPLICATION_REJECTED,
    APPLICATION_TERMINATED,
    APPLICATION_SPECIAL_OFFER,
    APPLICATION_YHAT_DECREASE,
    APPLICATION_YHAT_INCREASE,
    APPLICATION_VERIFICATION,
    APPLICATION_MANUAL_VERIFICATION,
  } = app.$tools.status;

  if (!app.$auth.loggedIn) {
    store.commit(MUTATION_TYPES.SET_FLOW_PERCENT, MUTATION_PAYLOAD.STEP1_PERCENT);
    return softRedirect(app.localePath(WEB_ROUTES.REGISTRATION_STEP_1));
  }

  const [routeName] = (route.name || '').split('___');

  await app.$auth.fetchUser();
  await app.$features.init();

  /** @type User */
  const user = app.$client.profile;

  if (
    !user.firstName ||
    !user.lastName ||
    !Object.keys(user.info).length ||
    !Object.keys(user.info.employment).length
  ) {
    store.commit(MUTATION_TYPES.SET_FLOW_PERCENT, MUTATION_PAYLOAD.STEP2_PERCENT);
    return softRedirect(app.localePath(WEB_ROUTES.REGISTRATION_STEP_2));
  }

  if (!Object.keys(user.info.primaryAddress).length) {
    store.commit(MUTATION_TYPES.SET_FLOW_PERCENT, MUTATION_PAYLOAD.STEP3_PERCENT);
    return softRedirect(app.localePath(WEB_ROUTES.REGISTRATION_STEP_3));
  }

  if (
    !user.hasApplications ||
    (!Object.keys(user.info.bank).includes('iban') &&
      !Object.keys(user.info.card).includes('mask') &&
      !Object.keys(user.info.wallet).includes('number'))
  ) {
    store.commit(MUTATION_TYPES.SET_FLOW_PERCENT, MUTATION_PAYLOAD.STEP4_PERCENT);
    return softRedirect(app.localePath(WEB_ROUTES.REGISTRATION_STEP_4));
  }

  if ([CLIENT_BLOCKED].includes(user.status)) {
    return app.$auth.logout();
  }

  if (routeName === WEB_ROUTES.APPLICATION_REJECTED && query.f) {
    return softRedirect(app.localePath(WEB_ROUTES.APPLICATION_REJECTED));
  }

  await store.dispatch(DISPATCH_API.CLIENT_GET_APPLICATION);

  /** @type Application */
  const application = app.$client && app.$client.application;

  if (
    user.isIdDocumentVerificationRequired &&
    [APPLICATION_VERIFICATION, APPLICATION_MANUAL_VERIFICATION, APPLICATION_CANCELED].includes(
      application.status
    )
  ) {
    store.commit(MUTATION_TYPES.SET_FLOW_PERCENT, MUTATION_PAYLOAD.UPLOAD_PHOTO);
    return softRedirect(app.localePath(WEB_ROUTES.REGISTRATION_UPLOAD));
  }

  if (application.paymentMethodChangeRequired) {
    return softRedirect(app.localePath(WEB_ROUTES.APPLICATION_CHANGE_IBAN));
  }

  if (application.status) {
    if (application.status === APPLICATION_REJECTED && application.canNotMakeApplication) {
      return softRedirect(app.localePath(WEB_ROUTES.APPLICATION_REJECTED));
    }

    if (application.status === APPLICATION_ACCEPTED) {
      return softRedirect(app.localePath(WEB_ROUTES.APPLICATION_ACCEPTED));
    }

    if ([APPLICATION_SPECIAL_OFFER, APPLICATION_YHAT_DECREASE].includes(application.status)) {
      return softRedirect(app.localePath(WEB_ROUTES.APPLICATION_OFFER));
    }

    if (application.status === APPLICATION_YHAT_INCREASE) {
      return softRedirect(app.localePath(WEB_ROUTES.APPLICATION_OFFER_INCREASE));
    }

    if (routeName === WEB_ROUTES.APPLICATION_LOADING) {
      return true;
    }

    if (
      ![
        APPLICATION_CANCELED,
        APPLICATION_COMPLETED,
        APPLICATION_REJECTED,
        APPLICATION_TERMINATED,
      ].includes(application.status)
    ) {
      return softRedirect(app.localePath(WEB_ROUTES.APPLICATION_LOADING));
    }
  }

  if (routeName === WEB_ROUTES.APPLICATION_APPLY) {
    return true;
  }

  if (!user.hasActiveLoan) {
    return softRedirect(app.localePath(WEB_ROUTES.PROFILE_NO_LOAN));
  }

  await store.dispatch(DISPATCH_API.CLIENT_GET_LOAN);
  await store.dispatch(DISPATCH_API.CLIENT_GET_PAYMENT_SCHEDULE);

  return softRedirect(app.localePath(WEB_ROUTES.PROFILE_MY_LOAN));
};
